import { WebRTCAdaptor } from "@/libs/webrtc_adaptor.js";
//import { getUrlParameter } from "@/libs/fetch.stream.js";

export const apiAnt = {
  iniciar(evento) {
    var pc_config = {
      iceServers: [
        {
          urls: "stun:stun1.l.google.com:19302"
        }
      ]
    };

    var sdpConstraints = {
      OfferToReceiveAudio: true,
      OfferToReceiveVideo: true
    };
    var mediaConstraints = {
      video: false,
      audio: false
    };

    var websocketURL = evento.servidor.replace("https://", "wss://") + ":5443/WebRTCAppEE/websocket";
    var streamId = evento["idCanal"];

    var webRTCAdaptor = new WebRTCAdaptor({
      websocket_url: websocketURL,
      mediaConstraints: mediaConstraints,
      peerconnection_config: pc_config,
      sdp_constraints: sdpConstraints,
      remoteVideoId: "remoteVideo",
      isPlayMode: true,
      debug: false,
      candidateTypes: ["tcp", "udp"],
      callback: function(info, obj) {
        if (info == "initialized") {
          console.log("initialized");

          var token = evento.antToken;
          var subscriberId = "";
          var subscriberCode = "";

          webRTCAdaptor.play(evento["idCanal"], token, "", [], subscriberId, subscriberCode);
        } else if (info == "play_started") {
          //joined the stream
          console.log("play started");
          //start_play_button.disabled = true;
          //stop_play_button.disabled = false;
          webRTCAdaptor.getStreamInfo(streamId);
          webRTCAdaptor.enableStats(obj.streamId);
        } else if (info == "play_finished") {
          //leaved the stream
          console.log("play finished");
          //start_play_button.disabled = false;
          //stop_play_button.disabled = true;
          //$("#stats_panel").hide();
          // Reset stream resolutions in dropdown
          //document.getElementById("dropdownMenu").innerHTML = '<a class="dropdown-item active" href="#">Automatic</a>';
        } else if (info == "closed") {
          //console.log("Connection closed");
          if (typeof obj != "undefined") {
            console.log("Connecton closed: " + JSON.stringify(obj));
          }
        } else if (info == "streamInformation") {
          var streamResolutions = new Array();

          obj["streamInfo"].forEach(function(entry) {
            //It's needs to both of VP8 and H264. So it can be dublicate
            if (!streamResolutions.includes(entry["streamHeight"])) {
              streamResolutions.push(entry["streamHeight"]);
            }
          });
          // Sort stream resolutions for good UI :)
          streamResolutions = streamResolutions.sort(function(a, b) {
            return a - b;
          });

          // Call set stream resolution
          webRTCAdaptor.forceStreamQuality(streamId, Number(0));
        } else if (info == "ice_connection_state_changed") {
          console.log("iceConnectionState Changed: ", JSON.stringify(obj));
        } else if (info == "updated_stats") {
          console.log("updated_stats");
        } else if (info == "data_received") {
          console.log("Data received: " + obj.event.data + " type: " + obj.event.type + " for stream: " + obj.streamId);
        } else if (info == "bitrateMeasurement") {
          console.debug(obj);
        } else {
          console.log(info + " notification received");
        }
      },
      callbackError: function(error) {
        //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError

        console.log("error callback: " + JSON.stringify(error));
        //alert(JSON.stringify(error));
      }
    });

    window.webRTCAdaptor = webRTCAdaptor;
  },
  view(evento) {
    this.iniciar(evento);
  }
};
